import Glide from '@glidejs/glide';
import { UtilSelector } from '../Core/Utils/UtilSelector.js';
import { ProjectSettings } from '../ProjectSettings.js';

class Slider {
    #sliders;

    constructor() {
        this.#sliders = document.querySelectorAll('.glide');
    }

    init() {
        const mainBreakpoint = Number.parseInt(UtilSelector.getRootVar('desktop-breakpoint', ProjectSettings.rootVarPrefix));
        
        this.#sliders.forEach((slider) => {
            let breakpoints = {};
            if (slider.dataset.perViewMobile) {
                breakpoints[mainBreakpoint] = {
                    perView: slider.dataset.perViewMobile
                }
            }
            const sliderGlide = new Glide(slider, {
                type: 'carousel',
                perView: slider.dataset.perView ? slider.dataset.perView : 1,
                autoplay: 6000,
                //autoplay: slider.dataset.autoplay ? slider.dataset.autoplay : false,
                hoverpause: true,
                animationDuration: slider.dataset.animationDuration ? slider.dataset.animationDuration : 500,
                animationTimingFunc: slider.dataset.animationTimingFunc ? slider.dataset.animationTimingFunc :  'ease-in-out',
                gap: slider.dataset.gap ? slider.dataset.gap : 0,
                breakpoints: breakpoints,
            });
            sliderGlide.on('mount.after', () => {
                // Trigger window ewent to fix slider item widths
                window.dispatchEvent(new Event('resize'));
            });
            sliderGlide.mount();
        });
    }
}

export {Slider};